import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useState} from "react";
import useRootHook from "../../hooks/useRoot";
import projects from "../../models/projects";
import helpers from "../../helpers/common";
import ProjectForm from "./ProjectForm";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function ProjectAdd(props) {
    const [searchParams] = useSearchParams();
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [errors, setErrors] = useState({});

    const defaultFields = searchParams.get('project_id') ? {project_id: parseInt(searchParams.get('project_id'))} : {}
    const [fields, setFields] = useState(defaultFields)

    const handleChange = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev)

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof projects.fieldValidator[name] === 'function'
        && projects.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = projects.methodValidator.add(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        projects.add(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/projects')
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Add project" breadcrumbs={[['Dashboard', '/'], ['Projects', '/projects'], ['Add', '/projects/add']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <ProjectForm fields={fields} setFields={setFields} errors={errors} setErrors={setErrors} handleChange={handleChange}
                              handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}